var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('UserIcon',{staticClass:"user-icon-helper",attrs:{"is-pc":_vm.isPc,"is-application":_vm.isApplication,"gaze-level":_vm.gazeLevel,"is-checked":_vm.isChecked}})
}
var staticRenderFns = []

export { render, staticRenderFns }